import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  deleteUser,
} from "firebase/auth";

const firebaseConfig = {
  apiKey:            "AIzaSyBws4sQx2GYKTZ-UT5F9qXKfe_R_WZKfbo",
  authDomain:        "checkvan-53dbe.firebaseapp.com",
  projectId:         "checkvan-53dbe",
  storageBucket:     "checkvan-53dbe.firebasestorage.app",
  messagingSenderId: "741901149628",
  appId:             "1:741901149628:web:1f37f3467d44ec16aff7b9",
};

const app = initializeApp(firebaseConfig);

export const db      = getFirestore(app);
export const auth    = getAuth(app);
export const storage = getStorage(app);

export const loginUser    = (email, pw) => signInWithEmailAndPassword(auth, email, pw);
export const registerUser = (email, pw) => createUserWithEmailAndPassword(auth, email, pw);
export const logoutUser          = ()          => signOut(auth);
export const onAuthChange        = (cb)        => onAuthStateChanged(auth, cb);
export const deleteUserAccount   = ()          => deleteUser(auth.currentUser);